declare global {
  interface Window {
    Pulse?: {
      open: () => void
      close: () => void
      toggle: () => void
      isOpen: () => boolean
      destroy: () => void
    }
  }
}

let dockFrame: HTMLIFrameElement | null = null
let dockOpened = false
let floatingHeldClosed = false

// @see https://github.com/Selectra-Dev/leo-myselectra/blob/develop/INTEGRATION.md
export const mountPulseWidget = (widgetUrl: string, spaceSlug: string, activationToken: string): void => {
  if (window.Pulse) {
    window.Pulse.open()
    return
  }

  const script = document.createElement('script')
  script.src = widgetUrl
  script.async = true
  script.dataset.space = spaceSlug
  script.dataset.activation = activationToken
  script.onload = () => {
    if (!floatingHeldClosed) window.Pulse?.open()
  }
  document.body.appendChild(script)
}

export const buildPulsePageUrl = (
  widgetUrl: string,
  spaceSlug: string,
  activationToken: string,
  pageUrl: string,
): string => {
  const url = new URL(`/${encodeURIComponent(spaceSlug)}`, widgetUrl)
  url.searchParams.set('activation', activationToken)
  url.searchParams.set('page_url', pageUrl)
  return url.toString()
}

export const closePulseWidget = (): void => {
  floatingHeldClosed = true
  window.Pulse?.close()
}

export const releasePulseWidget = (): void => {
  floatingHeldClosed = false
}

export const registerDockFrame = (frame: HTMLIFrameElement | null): void => {
  dockFrame = frame
  if (frame) dockOpened = true
}

export const wasDockOpened = (): boolean => dockOpened

export const destroyPulseWidget = (): void => {
  window.Pulse?.destroy()
  dockOpened = false

  if (!dockFrame?.contentWindow || !dockFrame.src) return
  dockFrame.contentWindow.postMessage({ type: 'pulse:destroy' }, new URL(dockFrame.src).origin)
}
